<!-- eslint-disable no-param-reassign -->
<template>
    <div class="w-full pt-5 pb-5">
      <div class="flex">
        <back-button
          label="Back"
          @onClick="
            $router.push({
              name: 'PerformanceSettings',
              query: { activeTab: 'Templates' },
            })
          "
          variant="secondary"
          class="mr-4"
        />
        <div
          class="mt-6"
          style="border-left: 1px solid #878e99; height: 1.5rem"
        />

        <div style="width: 100px; margin-top: 0.5rem">
          <h1 class="text-xl text-left font-extrabold ml-4 mt-3">
            Settings
          </h1>
        </div>
        <div class="" style="margin-top: 1.5rem">
          <Breadcrumb
            :items="breadcrumbs"
            @onClick="handleBreadcrumbClick($event)"
          />
        </div>
      </div>

      <div style="height: 100%" class="mt-28" v-if="loading">
        <loader size="xxs" :loader-image="false" />
      </div>

      <div class="px-3" v-else>
        <div>
          <p class="text-[12px] uppercase" style="font-weight:800;">
            Performance Templates
          </p>
        </div>
        <hr class="my-3"/>

        <ValidationObserver rules="required" v-slot="{ handleSubmit }">
          <PerformanceAccordion title="Contract period " info="`<p>The timeframe for employees to meet their <br/> performance goals as specified in their performance contracts.</p>`">


              <div class="grid grid-cols-2 gap-10 items-center">
                       <div class="flex-1 items-center w-[300px] ">
                <CSelect placeholder="Enter" :options="contractPeriodTypeOption" v-model="contractPeriodType" label="Type"
                    variant="w-full" class=" mr-2 !w-full" :rules="['required']"  style="width: 100%;" :disabled="isViewMode || isLinkMode"/>
            </div>
              <div class="flex-1">
              <label class="date-label"> Description</label>

              <div class=" flex items-center"
              style="border:1px solid #878E99;border-radius:5px;">

                <div class="date-flex"
                style="border-radius:0px !important;border:0px;border-right:1px solid #878E99">

                  <datepicker
                  placeholder="Select Year"
                  style="width:100px"
                  minimum-view="year"
                  maximum-view="year"
                  format="yyyy"
                  :required="true"
                  :rules="['required']"
                  v-model="contractPeriodYear"
                  :disabled="isViewMode || isLinkMode"
                  :input-class="isViewMode || isLinkMode ? 'date-input date-input_disabled' : 'date-input'"
                  />
                </div>

                <c-text
                    placeholder="Perf. agreement template"
                    class="labeldisplay"
                    style="outline: none; width:100%;border-radius:0;text-transform:capitalize;"
                    variant="w-full !rounded-[0] cld-input"
                    v-model="performanceTemplate.agreement_description"
                    :disabled="isViewMode || isLinkMode"
                    :input-class="isViewMode || isLinkMode ? 'date-input date-input_disabled' : 'date-input'"
                  />
                <div class=" text-romanSilver font-bold text-lg flex items-center !border-r-lg justify-center"
                    style="  border-radius: 0px 5px 5px 0px !important;border:0px;border-left:1px solid #878E99;width: 67px; height:40px; text-align: center; background:#eeeeee;"
                  >
                    {{ displayAlphabeticalSort }}
                  </div>
              </div>


              </div>

              <div class="flex-1">
                <label class="date-label">Start Date </label>
                <div class="date-flex ">
                  <datepicker
                    placeholder="--Select Day & Month--"
                    style="width: 100%; outline: none"
                    format="MMMM d, yyyy"
                    v-model="cycleStartDate"
                    :disabled="isViewMode || isLinkMode"
                    :input-class="isViewMode || isLinkMode ? 'date-input date-input_disabled' : 'date-input'"
                    />
                </div>
              </div>

              <div class="flex-1">
                <label class="date-label"> End Date </label>
                <div class="date-flex">
                  <datepicker
                    placeholder="--Select Day & Month--"
                    style="width: 100%; outline: none"
                    format="MMMM d, yyyy"
                    v-model="cycleEndDate"
                    :disabled="isViewMode || isLinkMode"
                    :input-class="isViewMode || isLinkMode ? 'date-input date-input_disabled' : 'date-input'"
                    />
                </div>
              </div>
            </div>
          </PerformanceAccordion>
          <PerformanceAccordion title="Agreement Setting Period "
          info="<p>The timeframe for formal documentation between line managers and their <br/> direct reports to establish clear performance expectations,<br/> goals, and responsibilities over a specified period</p>">


              <div class="grid grid-cols-2 gap-4 my-2">

                <div class="">
                  <label class="date-label">Start Date </label>
                  <div class="date-flex ">
                    <datepicker
                      placeholder="--Select Day & Month--"
                      style="width: 100%; outline: none"
                      format="MMMM d, yyyy"
                      v-model="agreementStartDate"
                      :disabled="isViewMode || isLinkMode"
                      :input-class="isViewMode || isLinkMode ? 'date-input date-input_disabled' : 'date-input'"
                    />
                  </div>
                </div>

                  <div class="">
                    <label class="date-label"> End Date </label>
                    <div class="date-flex">
                      <datepicker
                        placeholder="--Select Day & Month--"
                        style="width: 100%; outline: none"
                        format="MMMM d, yyyy"
                        v-model="agreementEndDate"
                        :disabled="isViewMode || isLinkMode"
                        :input-class="isViewMode || isLinkMode ? 'date-input date-input_disabled' : 'date-input'"
                        />
                    </div>
                  </div>
              </div>

               </PerformanceAccordion>

          <PerformanceAccordion title="KPAs" subtitle="KPA auto-loaded based on selected KPAs in 'Manage KPAs' " >
              <div class="flex w-full flex-wrap mt-10 items-center">

                <MultiSelectTag
                  bg-color="#FFFFFF"
                  v-for="(t, index) in selectedKPATags"
                  size="xms"
                  style="border: 1px solid #00000014;border-radius:8px;"
                  :key="index"
                  @close="isLinkMode ? deleteSelectedKPA(t.id) : null"
                  >
                  <div
                    class="text-jet flex flex-grow"
                    style="font-size: 14px; margin-right: 10px"
                  >
                    {{ t.name }}
                  </div>
              </MultiSelectTag>


            </div>

              </PerformanceAccordion>

              <PerformanceAccordion title="Performance Appraisal(s)" info=""
              :show-frequency="true"
      :initial-frequency="templateFrequency"
      :edit-appraisal="isEditing"
      @frequency-change="updateTemplateFrequency"
      :disabled="isViewMode || isLinkMode"
              >
              <ValidationObserver rules="required" v-slot="{ handleSubmit }">


                 <div class="w-full flex flex-col">
                  <div class=" grid grid-cols-3 font-bold pt-10 uppercase"
                  style="color: #878E99;font:900;font-size:12px;"
                  >
                      <p class="">Sequence</p>
                      <p class="">Start Date</p>
                      <p class="">End Date</p>
                  </div>

                    <div
                      class="grid grid-cols-3 gap-6 mt-4 mb-7"
                      v-for="(cycle, index) in appraisal_cycles"
                      :key="index"
                    >
                      <div
                        class=""
                        v-if="cycle.name !== null"
                      >
                        <div class="flex -mt-1 mb-1">

                          <c-text
                            placeholder="--Enter Name--"
                            variant="w-full mt-1"
                            class="label w-full"

                            v-model="cycle.label"
                            label="Description"
                            :rules="['required']"
                            :disabled="isViewMode  || isLinkMode"
                          />
                        </div>
                      </div>
                      <div class="">
                        <label class="date-label"> Appraisal Starts </label>
                        <div class="date-flex" :class="{'bg-disabled': isViewMode  || isLinkMode}">
                          <datepicker
                            placeholder="--Select Day & Month--"
                            style="width: 100%; outline: none"
                            format="MMMM d, yyyy"
                            v-model="cycle.appraisal_starts"
                            :disabled="isViewMode  || isLinkMode"
                            :rules="['required']"
                            :input-class="isViewMode ? 'date-input date-input_disabled' : 'date-input'"
                          />
                        </div>
                      </div>
                      <div class="">
                        <label class="date-label"> Appraisal Ends </label>
                        <div class="date-flex" :class="{'bg-disabled': isViewMode  || isLinkMode}">
                          <datepicker
                            placeholder="--Select Day & Month--"
                            style="width: 100%; outline: none"
                            format="MMMM d, yyyy"
                            v-model="cycle.appraisal_ends"
                            :disabled="isViewMode  || isLinkMode"
                            :rules="['required']"
                            :input-class="isViewMode ? 'date-input date-input_disabled' : 'date-input'"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="frequency === '5' && !isAgreementEnded"
                      class="text-flame font-semibold flex w-full mt-6 p-2 text-base cursor-pointer"
                      @click="handleSubmit(addAppraisal)"
                    >
                      <icon icon-name="icon-plus" class="mr-2" size="xsm" />
                      Add Another Appraisal
                    </div>
                </div>
                </ValidationObserver>
            </PerformanceAccordion>

        <PerformanceAccordion
        title="Performance Moderation (Optional)"
        v-feature-request
        :show-toggle="true"
        :add-moderator="addModerator"
        :checked="performanceTemplate.enable_moderation"
        @toggle-change="updateSettings({ enable_moderation: $event })"
        :is-open="false"
        >


        <div  class="gap-6 my-4">
          <div
            v-for="(moderator, index) in performanceTemplateModerators.moderators || []"
            :key="moderator.id"
            class="moderator-item group relative"
            draggable="true"
            @dragstart="handleDragStart(index)"
            @dragover.prevent="handleDragOver(index)"
            @drop="handleDrop(index)"
          >
            <div class="grid grid-cols-11 gap-5 mt-3">
              <div class="col-span-5 relative">
                <div class="!text-[16px]" style="font-size: 14px;margin-bottom:5px">
                  {{ ordinal(index + 1) }} Moderator
                </div>
                <v-select
                  :clearable="false"
                  :disabled="!performanceTemplate.enable_moderation || isViewMode || isLinkMode"
                  label="fname"
                  placeholder="search or select"
                  class="style-select"
                  style="height: 40px; border: none !important; outline: none !important"
                  :reduce="option => option.name"
                  v-model="moderator.moderator"
                  @search="setAllOrgUsers"
                  :options="allOrgUsers"
                  :filterable="true"
                />
              </div>
              <!-- Weight Input -->
              <div class="col-span-5">
                <c-text
                  placeholder="xxxxxxxxx"
                  variant="w-full"
                  :disabled="performanceTemplate.enable_moderation || isViewMode || isLinkMode"
                  label="Assign Weight %"
                  :rules="['required']"
                  v-model="moderator.weight"
                />
              </div>


              <div
              class="col-span-1 flex items-center justify-center  gap-3 mt-8"
              @mouse.stop
            >
            <div            @click.stop="deleteModerator(index)"
            >
            <icon
            icon-name="close" class=" text-flame cursor-pointer" size="xsm" />

            </div>

              <div  class="drag-handle  transition-opacity border cursor-move  !rounded-sm flex items-end p-2" style="border-radius: 4px;background:#F15A2914;border-color:#F15A2952">
                <icon icon-name="drag-icon" class=" text-flame" size="xsm" />

              </div>
            </div>
            </div>
          </div>

                   </div>

                   <div class="flex flex-row w-full mt-3">
                    <radio-button
                    :options="[{name:'Allow moderators to view other moderators scoring during the moderation phase'}]"
                    :col-span="`col-span-12

                  p-4 border-dashed rounded-sm`"
                    class="text-darkPurple"
                    row-gap=" gap-x-8"
                    space-between="mr-3"
                    v-model="applyTemplate"
                    @change="setApply"
                  />
                  </div>
      </PerformanceAccordion>

          <PerformanceAccordion title="Apply Template To Employees"
  subtitle="Select which employees can see and use this template. You can restrict this template to certain categories of employees, whether by location, function, level or designation.">


              <div class="flex flex-row w-full mt-3">
                <radio-button
                  :options="template_apply"
                  :col-span="`col-span-6

                p-4 border-dashed rounded-sm`"
                  class="text-darkPurple"
                  row-gap=" gap-x-8"
                  space-between="mr-3"
                  v-model="applyTemplate"
                  @change="setApply"
                />
              </div>

              <hr class="mb-3"/>

              <div
                class="flex flex-col p-4 border-r border-l border-b border-dashed"
                v-if="applyTemplate === 'selected'"
              >
                <div class="w-1/2">
                  <div class="flex -mt-1">
                    <span class="text-sm font-semibold flex flex-grow">
                      Selected Location(s)
                    </span>
                    <checkbox
                      checkbox-size="height:16px; width:16px; margin-top: 3px;"
                      label="All Locations"
                      v-model="applyToAllLocation"
                      :disabled="isViewMode"
                    />
                  </div>
                  <c-select
                    placeholder="--Select Applicable Locations--"
                    :options="locations"
                    variant="w-full"
                    class="w-full label"
                    :disabled="applyToAllLocation || isViewMode"
                    v-model="selectedLocation"
                    :rules="!applyToAllLocation ? ['required'] : []"
                  />

                  <Alert
                    message="Applying to employees in all locations !"
                    variant="primary"
                    :time="2"
                    style="
                      position: relative;
                      right: 0;
                      z-index: 0000;
                      top: 8px;
                      font-size: 14px;
                      width: 100%;
                      box-shadow: none;
                      background: rgba(233, 147, 35, 0.15);
                      color: #333333;
                      border: 1px solid rgba(233, 147, 35, 1);
                    "
                    v-if="applyToAllLocation"
                  />

                  <div
                    class="flex w-full flex-wrap mt-3"
                    v-if="!applyToAllLocation"
                  >
                    <MultiSelectTag
                      bg-color="#F7F7FF"
                      size="xms"
                      v-for="(l, index) in selectedLocationTags"
                      :key="index"
                      @close="deleteSelectedLocation(l.id)"
                    >
                      <div
                        class="text-jet flex flex-grow"
                        style="font-size: 14px; margin-right: 10px"
                      >
                        {{ l.name }}
                      </div>
                    </MultiSelectTag>
                  </div>
                </div>

                <div class="w-full my-4 flex">
                  <div
                    style="width: 33%; margin-right: 2%"
                    class="p-4 border flex flex-col rounded-sm"
                  >
                    <p class="mt-1 mb-3 text-base font-semibold">
                      Employees By Function
                    </p>
                    <div class="flex mt-3">
                      <span class="text-sm font-semibold flex flex-grow">
                        Functions
                      </span>
                      <checkbox
                        checkbox-size="height:16px; width:16px; margin-top: 3px;"
                        label="All Functions"
                        v-model="applyToAllFunction"
                        :disabled="isViewMode"
                      />
                    </div>
                    <c-select
                      placeholder="--Select Applicable Functions--"
                      :options="functions"
                      variant="w-full"
                      class="w-full label"
                      :disabled="applyToAllFunction || isViewMode"
                      @input="selectedFunction($event)"
                      v-model="selectedFunctionResponse"
                      :rules="!applyToAllFunction ? ['required'] : []"
                    />

                    <Alert
                      message="Applying to employees in all functions"
                      variant="primary"
                      :time="2"
                      style="
                        position: relative;
                        right: 0;
                        z-index: 0000;
                        top: 8px;
                        font-size: 14px;
                        width: 100%;
                        box-shadow: none;
                        background: rgba(233, 147, 35, 0.15);
                        color: #333333;
                        border: 1px solid rgba(233, 147, 35, 1);
                      "
                      v-if="applyToAllFunction"
                    />

                    <div
                      class="flex w-full flex-wrap mt-3"
                      v-if="!applyToAllFunction"
                    >
                      <MultiSelectTag
                        bg-color="#F7F7FF"
                        size="xms"
                        v-for="(functionTag, index) in selectedFunctionTags"
                        :key="index"
                        @close="deleteSelectedFunction(functionTag.id)"
                      >
                        <div
                          class="text-jet flex flex-grow"
                          style="font-size: 14px; margin-right: 10px"
                        >
                          {{ functionTag.name }}
                        </div>
                      </MultiSelectTag>
                    </div>
                  </div>

                  <div
                    style="width: 33%; margin-right: 2%"
                    class="p-4 border flex flex-col rounded-sm"
                  >
                    <p class="mt-1 mb-3 text-base font-semibold">
                      Employees By Job Level
                    </p>
                    <div class="flex mt-3">
                      <span class="text-sm font-semibold flex flex-grow">
                        Job Levels
                      </span>
                      <checkbox
                        checkbox-size="height:16px; width:16px; margin-top: 3px;"
                        label="All Job Levels"
                        v-model="applyToAllJobLevel"
                        :disabled="isViewMode"
                      />
                    </div>
                    <c-select
                      placeholder="--Select Applicable Job Levels--"
                      :options="jobLevels"
                      variant="w-full"
                      class="w-full label"
                      :disabled="applyToAllJobLevel || isViewMode"
                      v-model="selectedLevel"
                      :rules="!applyToAllJobLevel ? ['required'] : []"
                    />

                    <Alert
                      message="Applying to employees of all levels"
                      variant="primary"
                      :time="2"
                      style="
                        position: relative;
                        right: 0;
                        z-index: 0000;
                        top: 8px;
                        font-size: 14px;
                        width: 100%;
                        box-shadow: none;
                        background: rgba(233, 147, 35, 0.15);
                        color: #333333;
                        border: 1px solid rgba(233, 147, 35, 1);
                      "
                      v-if="applyToAllJobLevel"
                    />

                    <div
                      class="flex w-full flex-wrap mt-3"
                      v-if="!applyToAllJobLevel"
                    >
                      <MultiSelectTag
                        bg-color="#F7F7FF"
                        size="xms"
                        v-for="(level, index) in selectedLevelTags"
                        :key="index"
                        @close="deleteSelectedLevel(level.id)"
                      >
                        <div
                          class="text-jet flex flex-grow"
                          style="font-size: 14px; margin-right: 10px"
                        >
                          {{ level.name }}
                        </div>
                      </MultiSelectTag>
                    </div>
                  </div>

                  <div
                    style="width: 33%; margin-right: 0%"
                    class="p-4 border flex flex-col rounded-sm"
                  >
                    <p class="mt-1 mb-3 text-base font-semibold">
                      Employees By Designation
                    </p>
                    <div class="flex mt-3">
                      <span class="text-sm font-semibold flex flex-grow">
                        Designations
                      </span>
                      <checkbox
                        checkbox-size="height:16px; width:16px; margin-top: 3px;"
                        label="All Designations"
                        v-if="designations.length > 0"
                        v-model="applyToAllDesignation"
                        :disabled="isViewMode || disableCheckBox"
                      />
                    </div>
                    <c-select
                      placeholder="--Select Applicable Designations--"
                      :options="designations"
                      variant="w-full"
                      class="w-full label"
                      :disabled="applyToAllDesignation || isViewMode"
                      v-model="selectedDesignation"
                      :rules="
                        !applyToAllDesignation && designations.length > 0
                          ? ['required']
                          : []
                      "
                    />
                    <Alert
                      message="Select at least one function to be able to see all applicable designations..."
                      variant="primary"
                      :time="2"
                      style="
                        position: relative;
                        right: 0;
                        z-index: 0000;
                        top: 12px;
                        font-size: 12px;
                        width: 100%;
                        box-shadow: none;
                        background: rgba(234, 60, 83, 0.15);
                        color: #ea3c53;
                      "
                      v-if="
                        designations.length === 0 &&
                        selectedDesignationTags.length === 0
                      "
                    />
                    <div
                      class="flex w-full flex-wrap mt-3"
                      v-if="!applyToAllDesignation"
                    >
                      <MultiSelectTag
                        bg-color="#F7F7FF"
                        size="xms"
                        v-for="(designation, index) in selectedDesignationTags"
                        :key="index"
                        @close="deleteSelectedDesignation(designation.id)"
                      >
                        <div
                          class="text-jet flex flex-grow"
                          style="font-size: 14px; margin-right: 10px"
                        >
                          {{ designation.name }}
                        </div>
                      </MultiSelectTag>
                    </div>
                  </div>
                </div>
              </div>
          </PerformanceAccordion>

          <div class="flex mt-5" v-if="!isViewMode">
            <div class="flex flex-grow">
              <Button
                class="bg-dynamicBackBtn text-white text-center"
                width="8rem"
                @click="handleSubmit(handleSaveTemplate)"
                :disabled="disableBtn"
              >
                Save
              </Button>
              <Button
                background-color="none"
                class="ml-4 text-darkPurple text-center"
                width="8rem"
                @click="
                  $router.push({
                    name: 'PerformanceSettings',
                    query: { activeTab: 'Templates' },
                  })
                "
              >
                Cancel
              </Button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </template>

  <script>
  import { ValidationObserver } from "vee-validate";
  import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
  import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
  import Alert from "@scelloo/cloudenly-ui/src/components/alert";
  import CSelect from "@scelloo/cloudenly-ui/src/components/select";
  import Datepicker from "vuejs-datepicker";
  import CText from "@scelloo/cloudenly-ui/src/components/text";
  import RadioButton from "@/components/RadioButton";
  import Checkbox from "@/components/Checkbox";
  import MultiSelectTag from "@/components/MultiSelectTag";
  import Button from "@/components/Button";
  import paramsMixin from '@/utilities/paramsMixin';
  import timeFormatMixin from "@/utilities/timeFormatMixin";
  import PerformanceAccordion from './PerformanceAccordion';
  import "vue-select/dist/vue-select.css";

  export default {
    name: "ViewTemplateSettings",
    mixins: [paramsMixin, timeFormatMixin],
    components: {
      ValidationObserver,
      BackButton,
      Checkbox,
      MultiSelectTag,
      Breadcrumb,
      Alert,
      Button,
      Datepicker,
      RadioButton,
      CSelect,
      CText,
      PerformanceAccordion,
      vSelect: () => import("vue-select"),

    },

    data() {
      return {
        templateFrequency: '',
        isEditing: false,
        breadcrumbs: [
          {
            disabled: false,
            text: "Settings",
            href: "Settings",
            id: "Settings",
          },
          {
            disabled: false,
            text: "Performance",
            href: "PerformanceSettings",
            id: "Performance",
          },
          {
            disabled: false,
            text: "Template",
            href: "PerformanceSettings",
            id: "Template",
          },
          {
            disabled: false,
            text: "View Template",
            id: "TemplateSettings",
          },
        ],
        performanceTemplateModerators: {
          enable_moderation: false,
          moderators: [
            { id: 1, moderator: null, weight: '' },
            { id: 2, moderator: null, weight: '' }
          ]
        },
        moderators: [
    { id: 1, moderator: null, weight: '' },
    { id: 2, moderator: null, weight: '' }
  ],
        moderator_allow: [
          {
            name: "Allow moderators to view other moderators scoring during the moderation phase",
            radioName: "allow_moderator",
            value: "all",
          }
        ],
        template_apply: [
          {
            name: "Apply to All Employees",
            radioName: "template_right",
            value: "all",
          },
          {
            name: "Apply to Selected Employees",
            radioName: "template_right",
            value: "selected",
          },
        ],
        documentation_apply: [
          {
            name: "Manager to document",
            radioName: "document",
            value: "manager",
          },
          {
            name: "Employee to document",
            radioName: "document",
            value: "employee",
          },
          { name: "Both", radioName: "document", value: "both" },
        ],
        contractPeriodTypeOption: [
          { id: 1, name: "Annual" },
          { id: 2, name: "Special Project" },

        ],
        optionsPeriod: [
          { id: 1, name: "Annual" },
          { id: 2, name: "Bi-Annual" },
          { id: 4, name: "Quarterly" },
          { id: 5, name: "Custom" },
        ],
        alphabetOptions: [
        { id: 'A', name: 'A' },
        { id: 'B', name: 'B' },
        { id: 'C', name: 'C' },
        { id: 'D', name: 'D' },
        { id: 'E', name: 'E' },
        { id: 'F', name: 'F' },
        { id: 'G', name: 'G' },
        { id: 'H', name: 'H' },
        { id: 'I', name: 'I' },
        { id: 'J', name: 'J' },
        { id: 'K', name: 'K' },
        { id: 'L', name: 'L' },
        { id: 'M', name: 'M' },
        { id: 'N', name: 'N' },
        { id: 'O', name: 'O' },
        { id: 'P', name: 'P' },
        { id: 'Q', name: 'Q' },
        { id: 'R', name: 'R' },
        { id: 'S', name: 'S' },
        { id: 'T', name: 'T' },
        { id: 'U', name: 'U' },
        { id: 'V', name: 'V' },
        { id: 'W', name: 'W' },
        { id: 'X', name: 'X' },
        { id: 'Y', name: 'Y' },
        { id: 'Z', name: 'Z' }
      ],
        optionsVal: "1",
        AnnualAppraisal: [
          {
            value: "Mid-Year Review",
            label: "Final Appraisal",
          },
        ],
        BiAppraisal: [
          {
            value: "Mid-Year Review",
            label: "First Appraisal",
          },
          {
            value: "Final Appraisal",
            label: "Final Appraisal",
          },
        ],
        QAppraisal: [
          {
            value: "Q1 Appraisal",
            label: "First Appraisal",
          },
          {
            value: "Q2 Appraisal",
            label: "Second Appraisal",
          },
          {
            value: "Q3 Appraisal",
            label: "Third Appraisal",
          },
          {
            value: "Q4 Appraisal",
            label: "Final Appraisal",
          },
        ],
        disabledDates: {
          from: "",
          to: "", // Disable all dates up to specific date
        },
        disableModerationDates: {
          from: "",
          to: "",
        },
        disableBtn: false,
        appraisalEndDate: "",
        loading: true,
        setModeration: false,
        applyTemplate: "all",
        selectedKPA: "",
        selectedKPATags: [],
        optionsKPA: [],
        kpaTypes: [],
        locations: [],
        selectedLocation: "",
        selectedLocationTags: [],
        jobLevels: [],
        selectedLevel: "",
        selectedLevelTags: [],
        functions: [],
        selectedFunctionResponse: "",
        selectedFunctionTags: [],
        designations: [],
        disableCheckBox: false,
        allDesignations: [],
        filteredDesignations: [],
        selectedDesignation: "",
        selectedDesignationTags: [],
        applyToAllLocation: false,
        applyToAllJobLevel: false,
        applyToAllFunction: false,
        applyToAllDesignation: false,
        performanceTemplate: {
          orgId: null,
          title: "",
          type: "",
          year: "",
          performance_template_status: "draft",
          kpa_types: [],
          appraisalCycleId: "",
          agreement_title: "",
          agreement_description: "",
          status: "draft",
          linkId: "",
          template_link: [],
          performance_agreement: {
            title: "",
            appraisal_frequency: "Annual",
            cycle_start_date: "",
            cycle_end_date: "",
            description: "",
            appraisalCycleId: "",
            appraisal_cycles: [],
          },
          enable_moderation: false,
          functional_moderation_start: "",
          functional_moderation_end: "",
          ceo_moderation_start: "",
          ceo_moderation_end: "",
          appliedTemplateTo: {
            applyToAllLocation: true,
            locationIds: [],
            applyToAllJobLevel: true,
            jobLevelIds: [],
            applyToAllFunction: true,
            functionIds: [],
            applyToAllDesignation: true,
            designationIds: [],
          },
        },
        frequency: null,
        contractPeriodType: null,
        payloadFrequency: "",
        alphabeticalSort: "A",
        appraisal_cycles: [],
        cycleStartDate: "",
        contractPeriodYear: new Date().getFullYear().toString(),
        cycleEndDate: "",
        agreementStartDate: "",
        agreementEndDate: "",
        functionalStart: "",
        functionalEnd: "",
        ceoStart: "",
        ceoEnd: "",
        linkNo:'',
        weightRules: [
          "required",
          {
            name: "value",
            rule: (w) => this.validateWeight(w),
          },
        ],
        locationRules: [
          {
            name: "value",
            rule: (l) => this.validateLocation(l),
          },
        ],
        activeTab: "Cycles",
        kpaModal: false,
        tabsItems: [
          "Cycles",
          "Agreement Templates",
          "Targets, Ratings & Rankings",
          "Personal Development Plans",
          "Preferences",
        ],
        allOrgUsers: [],
        search:'',
        userId:'',
        draggedIndex: null,
        draggedOverIndex: null,
        cycleValidation: false,
        originalCycleData: null, // Store original cycle data for comparison
        appraisalCyclePayload: {
          orgId: "",
          appraisal_frequency: "",
          cycle_start_date: "",
          cycle_end_date: "",
          status: "active",
          agreement_start: "",
          agreement_end: "",
          appraisal_cycles: [],
        },
        appraisalCycleId : ''
      };
    },

    watch: {
      ceoStart(value) {
        this.performanceTemplate.ceo_moderation_start = this.formatDate(value);
      },

      ceoEnd(value) {
        this.performanceTemplate.ceo_moderation_end = this.formatDate(value);
      },

      functionalStart(value) {
        this.performanceTemplate.functional_moderation_start =
          this.formatDate(value);
      },

      functionalEnd(value) {
        this.performanceTemplate.functional_moderation_end =
          this.formatDate(value);
      },

      frequency(value) {
        this.appraisal_cycles = [];
        const payloadCycles =
          this.performanceTemplate.performance_agreement.appraisal_cycles;

        if (value !== "5") {
          for (let i = 0; i < value; i++) {
            this.appraisal_cycles.push({
              name:
                this.payloadFrequency === value
                  ? payloadCycles[i].name
                  : this.getCycleName(Number(value), i),
              label: this.payloadFrequency === value && payloadCycles[i].label
                ? payloadCycles[i].label
                : this.getCycleLabel(Number(value), i),
              checkName: false,
              appraisal_starts:
                this.payloadFrequency === value
                  ? this.setDates(payloadCycles[i].appraisal_starts)
                  : "",
              appraisal_ends:
                this.payloadFrequency === value
                  ? this.setDates(payloadCycles[i].appraisal_ends)
                  : "",
              weight:
                this.payloadFrequency === value ? payloadCycles[i].weight : "",
            });
          }
        } else if (value === "5" && this.payloadFrequency === "5") {
          for (let i = 0; i < payloadCycles.length; i++) {
            this.appraisal_cycles.push({
              name: payloadCycles[i].name,
              label: payloadCycles[i].label || this.getCycleLabel(Number(value), 0),
              checkName: true,
              appraisal_starts:
                payloadCycles[i].appraisal_starts === ""
                  ? ""
                  : this.setDates(payloadCycles[i].appraisal_starts),
              appraisal_ends:
                payloadCycles[i].appraisal_ends === ""
                  ? ""
                  : this.setDates(payloadCycles[i].appraisal_ends),
              weight: payloadCycles[i].weight,
            });
          }
        } else {
          this.appraisal_cycles.push({
            name: "First Appraisal",
            label: this.getCycleLabel(Number(value), 0),
            checkName: true,
            appraisal_starts: "",
            appraisal_ends: "",
            weight: "",
          });
        }
      },

      applyToAllLocation(allLocation) {
        if (allLocation) {
          this.selectedLocation = "";
          this.selectedLocationTags = [];
          this.getLocation();
          this.checkTemplateEmployeeApplication();
        }

        this.performanceTemplate.appliedTemplateTo.applyToAllLocation =
          allLocation;
      },

      selectedLocation() {
        this.locations.filter((location) => {
          if (location.id === this.selectedLocation) {
            this.selectedLocationTags.push({
              id: location.id,
              name: location.name,
            });
          }
          return {};
        });

        const disableIndex = this.locations
          .map((item) => item.id)
          .indexOf(this.selectedLocation);

        document
          .querySelectorAll("select")[2]
          .options[disableIndex + 1].setAttribute("disabled", true);
      },

      applyToAllJobLevel(allLevels) {
        if (allLevels) {
          this.selectedLevel = "";
          this.selectedLevelTags = [];
          this.getJobLevels();
          this.checkTemplateEmployeeApplication();
        }

        this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = allLevels;
      },

      selectedLevel() {
        this.jobLevels.filter((level) => {
          if (level.id === this.selectedLevel) {
            this.selectedLevelTags.push({
              id: level.id,
              name: level.name,
            });
          }
          return {};
        });

        const disableIndex = this.jobLevels
          .map((item) => item.id)
          .indexOf(this.selectedLevel);

        document
          .querySelectorAll("select")[4]
          .options[disableIndex + 1].setAttribute("disabled", true);
      },

      applyToAllFunction(allFunctions) {
        if (allFunctions) {
          this.selectedFunction = "";
          this.selectedFunctionTags = [];
          this.functions = [];
          this.getFunctions();
          this.getDesignations("");
          this.checkTemplateEmployeeApplication();
        } else {
          this.designations = [];
        }

        this.performanceTemplate.appliedTemplateTo.applyToAllFunction =
          allFunctions;

        this.disableCheckBox = false;
      },

      selectedFunctionResponse() {
        this.functions.filter((f) => {
          if (f.id === this.selectedFunctionResponse) {
            this.selectedFunctionTags.push({
              id: f.id,
              name: f.name,
            });
          }
          return {};
        });

        const disableIndex = this.functions
          .map((item) => item.id)
          .indexOf(this.selectedFunctionResponse);

        document
          .querySelectorAll("select")[3]
          .options[disableIndex + 1].setAttribute("disabled", true);

        if (this.selectedFunctionResponse !== "") {
          this.applyToAllDesignation = false;
          this.disableCheckBox = true;
        }
      },

      applyToAllDesignation(allDesignations) {
        if (allDesignations) {
          this.selectedDesignation = "";
          this.selectedDesignationTags = [];
          this.checkTemplateEmployeeApplication();
        }

        this.performanceTemplate.appliedTemplateTo.applyToAllDesignation =
          allDesignations;
      },

      selectedDesignation() {
        this.designations.filter((designation) => {
          if (designation.id === this.selectedDesignation) {
            this.selectedDesignationTags.push({
              id: designation.id,
              name: designation.name,
            });
          }
          return {};
        });

        const disableIndex = this.designations
          .map((item) => item.id)
          .indexOf(this.selectedDesignation);

        document
          .querySelectorAll("select")[5]
          .options[disableIndex + 1].setAttribute("disabled", true);
      },

      linkNo() {
      },
    },
    computed: {
      isViewMode() {
        return (
          this.$route.query.mode === 'view'
        );
      },
      isLinkMode() {
        return (
          this.$route.path.endsWith('/link') ||
          this.$route.query.mode === 'link'
        );
      },
      displayAlphabeticalSort() {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        if (typeof this.linkNo !== 'number' || this.linkNo < 1) return '';
        if (this.isViewMode) {
          return letters[this.linkNo - 1];
        }
        if (this.isLinkMode) {
          return letters[this.linkNo];
        }
        return '';
      },
      shouldShowFrequency() {
        return this.templateType === 'performance' || this.someOtherCondition;
      },
      filteredGroups() {
        const groups =  this.groups.filter(group => group.id !== (this.item.group?.id || null));
        return [this.addNewGroupOption, ...groups];
      },
      isAgreementEnded() {
        if (!this.cycleEndDate) return false;
        const today = new Date();
        const endDate = new Date(this.cycleEndDate);
        return today === endDate;
      }
    },

    methods: {
      updateTemplateFrequency(newFrequency) {
        this.templateFrequency = newFrequency;
        this.frequency = newFrequency;
        this.appraisal_cycles = [];
        switch(newFrequency) {
          case '1': // Annual
            this.appraisal_cycles = [{
              name: 'Annual Appraisal',
              label: 'Single Appraisal',
              appraisal_starts: null,
              appraisal_ends: null,
              weight: '100',
              isLocked: false
            }];
            break;
          case '2': // BiAnnual
            this.appraisal_cycles = [
              {
                name: 'Mid-Year Review',
                label: 'First Appraisal',
                appraisal_starts: null,
                appraisal_ends: null,
                weight: '50',
                isLocked: false
              },
              {
                name: 'Final Appraisal',
                label: 'Second Appraisal',
                appraisal_starts: null,
                appraisal_ends: null,
                weight: '50',
                isLocked: false
              }
            ];
            break;
          case '5': // Custom
            this.appraisal_cycles = [{
              name: 'First Appraisal',
              label: 'Appraisal 1',
              appraisal_starts: null,
              appraisal_ends: null,
              weight: null,
              isLocked: false
            }];
            break;
          default:
            this.appraisal_cycles = [];
            break;
        }
      },


      addModerator() {
        if (!this.performanceTemplate.enable_moderation) return;
              const newModerator = {
          id: Date.now(),
          moderator: null,
          weight: ''
        };
        this.performanceTemplateModerators.moderators.push(newModerator);
      },
      handleDragStart(index) {
    this.draggedIndex = index;
  },
  handleDragOver(index) {
    this.draggedOverIndex = index;
  },
  handleDrop(targetIndex) {
    if (this.draggedIndex === null) return;

    const items = [...this.performanceTemplateModerators.moderators];
    const draggedItem = items[this.draggedIndex];

    let newTargetIndex = targetIndex; // Assign to a new variable

    if (this.draggedIndex < newTargetIndex) {
      newTargetIndex -= 1;
    }

    items.splice(this.draggedIndex, 1);
    items.splice(newTargetIndex, 0, draggedItem);

    this.performanceTemplateModerators.moderators = items;

    this.draggedIndex = null;
    this.draggedOverIndex = null;
  },
  ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  },
  deleteModerator(index) {
    this.performanceTemplateModerators.moderators.splice(index, 1);
  },

  updateSettings(newSettings) {
      Object.assign(this.performanceTemplate, newSettings);
    },
  async setAllOrgUsers(search, loading) {
              loading(true);
              try {
                  const attributes = "id,fname,lname,photo,userId";
                  const { data } = await this.$_getAllEmployeesWithQueries(
                  `search=${search}&perPage=1000&payrollStatus=active&attributes=${attributes}`
                  );
                  this.allOrgUsers = data.data.employees;
                  loading(false);
              } catch (err) {
                  throw new Error(err);
              }
          },
          handleSelect(selected) {
              this.search = selected.userDesignation.name;
          },

          isSelect(option) {
              this.userId = option.id
              return option
          },


      activateTab(tab) {
        this.activeTab = tab;
      },
    async handleSaveTemplate() {
      if (this.isLinkMode) {
        const template = this.performanceTemplate;
        if (!template.agreement_description) {
          this.$toasted.error('Description is required', { duration: 5000 });
          return;
        }
        const payload = {
          orgId: this.$orgId,
          title: template.agreement_description,
          isLinked: true,
          linkId: template.linkId,
          type: template.type,
          year: template.year,
          performance_template_status: 'active',
          kpa_types: Array.isArray(template.kpa_types)
            ? template.kpa_types.map(k => (typeof k === 'object' && k.id ? k.id : k))
            : [],
          appraisalCycleId: template.appraisalCycleId,
          agreement_title: template.agreement_title,
          agreement_description: template.agreement_description,
          status: 'active',
          enable_moderation: template.enable_moderation,
          functional_moderation_start: template.functional_moderation_start,
          functional_moderation_end: template.functional_moderation_end,
          ceo_moderation_start: template.ceo_moderation_start,
          ceo_moderation_end: template.ceo_moderation_end,
          appliedTemplateTo: template.appliedTemplateTo
        };
        try {
          await this.$handlePrivilege('performance', 'editTemplateUsage');
          const response = await this.$_createPerfomanceTemplate(payload);
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.$router.push({
            name: 'PerformanceSettings',
            query: { activeTab: 'Templates' }
          });
        } catch (error) {
          this.$toasted.error(error.response?.data?.message || 'Failed to create linked template', { duration: 5000 });
        }
        return;
      }
      try {
        await this.$handlePrivilege('performance', 'editTemplateUsage');
        this.organizeTemplate();
      } catch (error) {
        this.$toasted.error('You do not have permission to perform this task', {
          duration: 5000
        });
      }
    },

      selectedFunction(val) {
        const disableIndex = this.functions
          .map((item) => item.id)
          .indexOf(val);

        document
          .querySelectorAll("select")[3]
          .options[disableIndex + 1].setAttribute("disabled", true);

        if (val !== "") {
          this.getDesignations(val);
          this.applyToAllDesignation = false;

          this.disableCheckBox = true;
        }
      },

      setApply(value) {
        this.apply = value;

        if (value === "all") {
          this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = true;
          this.performanceTemplate.appliedTemplateTo.applyToAllFunction = true;
          this.performanceTemplate.appliedTemplateTo.applyToAllLocation = true;
          this.performanceTemplate.appliedTemplateTo.applyToAllDesignation = true;
        } else {
          this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = false;
          this.performanceTemplate.appliedTemplateTo.applyToAllFunction = false;
          this.performanceTemplate.appliedTemplateTo.applyToAllLocation = false;
          this.performanceTemplate.appliedTemplateTo.applyToAllDesignation = false;
        }
      },

      addAppraisal() {
        if (!this.isAgreementEnded) return;
        const index = this.appraisal_cycles.length;
        this.appraisal_cycles.push({
          name: `Appraisal ${index + 1}`,
          label: `Appraisal ${index + 1}`,
          appraisal_starts: null,
          appraisal_ends: null,
          weight: null,
          isLocked: false
        });
      },

      validateWeight(w) {
        if (w < 0) {
          return `Value must be greater than or equal to 0`;
        }
        if (w > 0) {
          return this.watchWeightMax();
        }

        return true;
      },

      watchWeightMax() {
        let sum = 0;
        this.appraisal_cycles.map((cycle) => {
          const cycleConst = cycle;

          cycleConst.weight = Number(cycle.weight);

          sum += cycleConst.weight;
          return {};
        });

        if (sum > 100) {
          return "Total weight must not be greater than 100%";
        }

        return true;
      },

      getCycleName(type, index) {
        if (type === 1) {
          return this.AnnualAppraisal[index].value;
        }
        if (type === 2) {
          return this.BiAppraisal[index].value;
        }

        if (type === 4) {
          return this.QAppraisal[index].value;
        }

        return null;
      },

      getCycleLabel(type, index) {
        if (type === 1) {
          return this.AnnualAppraisal[index].label;
        }

        if (type === 2) {
          return this.BiAppraisal[index].label;
        }

        if (type === 4) {
          return this.QAppraisal[index].label;
        }

        if (type === 5) {
          return `Appraisal ${index + 1}`;
        }

        return null;
      },

      setAppraisalFreq(value) {
        if (value === "") {
          this.frequency = "1";
        } else {
          this.optionsPeriod.filter((freq) => {
            if (value === freq.name) {
              this.frequency = freq.id.toString();
              this.payloadFrequency = freq.id.toString();
            }
            return {};
          });
        }
      },

      organizeTemplate(type) {
        if (!this.validateCycleData()) {
          this.$toasted.error("Please fill in all required cycle dates and appraisal information", {
            duration: 5000,
          });
          return;
        }
        const needsNewCycle = this.shouldCreateNewCycle();

        if (needsNewCycle) {
          this.createAppraisalCycle()
            .then((cycleId) => {
              this.performanceTemplate.appraisalCycleId = cycleId;
              this.prepareTemplateData(type);
            })
            .catch((error) => {
              const errorMessage = error.response?.data?.message || "";
              if (errorMessage.includes("Already Exist") || errorMessage.includes("already exists")) {
                this.$toasted.info("Appraisal cycle already exists, proceeding with template creation", {
                  duration: 3000,
                });
                this.prepareTemplateData(type);
              } else {
                this.$toasted.error("Failed to create appraisal cycle", {
                  duration: 5000,
                });
              }
            });
        } else {
          this.prepareTemplateData(type);
        }
      },

      shouldCreateNewCycle() {
        if (this.$route.params.id === "new") {
          return true;
        }

        if (!this.appraisalCycleId) {
          return true;
        }

        if (this.originalCycleData) {
          const contractYear = parseInt(this.contractPeriodYear, 10);
          let appraisalCycleYear = null;

          if (this.originalCycleData.cycleStartDate) {
            appraisalCycleYear = new Date(this.originalCycleData.cycleStartDate).getFullYear();
          } else if (this.originalCycleData.cycleEndDate) {
            appraisalCycleYear = new Date(this.originalCycleData.cycleEndDate).getFullYear();
          } else if (this.originalCycleData.agreementStartDate) {
            appraisalCycleYear = new Date(this.originalCycleData.agreementStartDate).getFullYear();
          }

          if (appraisalCycleYear && appraisalCycleYear !== contractYear) {
            return true;
          }
        }

        return false;
      },

      prefillDefaultCycleData() {
        // Use the data that was already loaded by getAppraisalCycle()
        // The getAppraisalCycle method already sets all the necessary data
        // We just need to ensure we have the originalCycleData for comparison
        if (!this.originalCycleData) {
          this.originalCycleData = {
            cycleStartDate: this.cycleStartDate,
            cycleEndDate: this.cycleEndDate,
            agreementStartDate: this.agreementStartDate,
            agreementEndDate: this.agreementEndDate,
            frequency: this.frequency,
            appraisal_cycles: [...this.appraisal_cycles]
          };
        }
      },

      saveTemplate() {
        this.performanceTemplate.performance_template_status = "active";
        this.performanceTemplate.status = "active";
        this.performanceTemplate.orgId = this.$orgId;
        this.performanceTemplate.title = this.performanceTemplate.agreement_description;
        this.performanceTemplate.appraisalCycleId = this.appraisalCycleId;
        this.performanceTemplate.agreement_title = this.performanceTemplate.agreement_description;
        this.performanceTemplate.year = this.contractPeriodYear;
              this.performanceTemplate.type = "annual";
        this.performanceTemplate.isLinked = true;

        this.$_createPerfomanceTemplate(this.performanceTemplate)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.$router.push({
              name: "PerformanceSettings",
              query: { activeTab: "Templates" },
            });
          })
          .catch((error) => {
            this.$toasted.error(error.response.data.message, { duration: 5000 });
          });
      },

      deleteSelectedDesignation(id) {
        const optionsIndex = this.designations.map((item) => item.id).indexOf(id);
        const selectedIndex = this.selectedDesignationTags
          .map((item) => item.id)
          .indexOf(id);

        this.selectedDesignationTags.splice(selectedIndex, 1);
        document
          .querySelectorAll("select")[5]
          .options[optionsIndex + 1].removeAttribute("disabled");

        if (this.selectedDesignationTags.length === 0) {
          this.selectedDesignation = "";
        }
      },

      deleteSelectedFunction(id) {
        const optionsIndex = this.functions.map((item) => item.id).indexOf(id);
        const selectedIndex = this.selectedFunctionTags
          .map((item) => item.id)
          .indexOf(id);

        this.selectedFunctionTags.splice(selectedIndex, 1);
        document
          .querySelectorAll("select")[3]
          .options[optionsIndex + 1].removeAttribute("disabled");

        if (this.selectedFunctionTags.length === 0) {
          this.selectedFunctionResponse = "";
          this.designations = [];
        } else {
          this.allDesignations.filter((designation) => {
            if (id === designation.functionId) {
              this.deleteSelectedDesignation(designation.id);
            }
            return {};
          });

          this.designations = [];
          this.selectedFunctionTags.forEach((tag) => {
            this.getDesignations(tag.id);
          });
        }
      },

      deleteSelectedLevel(id) {
        const optionsIndex = this.jobLevels.map((item) => item.id).indexOf(id);
        const selectedIndex = this.selectedLevelTags
          .map((item) => item.id)
          .indexOf(id);

        this.selectedLevelTags.splice(selectedIndex, 1);
        document
          .querySelectorAll("select")[4]
          .options[optionsIndex + 1].removeAttribute("disabled");

        if (this.selectedLevelTags.length === 0) {
          this.selectedLevel = "";
        }
      },

      deleteSelectedLocation(id) {
        const optionsIndex = this.locations.map((item) => item.id).indexOf(id);
        const selectedIndex = this.selectedLocationTags
          .map((item) => item.id)
          .indexOf(id);

        this.selectedLocationTags.splice(selectedIndex, 1);
        document
          .querySelectorAll("select")[2]
          .options[optionsIndex + 1].removeAttribute("disabled");

        if (this.selectedLocationTags.length === 0) {
          this.selectedLocation = "";
        }
      },

      deleteSelectedKPA(id) {
      const optionsIndex = this.selectedKPATags.map((item) => item.id).indexOf(id);
      const selectedIndex = this.selectedKPATags
        .map((item) => item.id)
        .indexOf(id);

      this.selectedKPATags.splice(selectedIndex, 1);
      document
        .querySelectorAll("select")[1]
        .options[optionsIndex + 1].removeAttribute("disabled");

      if (this.selectedKPATags.length === 0) {
        this.selectedKPA = "";
      }
      // Keep performanceTemplate.kpa_types in sync in linked mode
      if (this.isLinkMode) {
        this.performanceTemplate.kpa_types = this.selectedKPATags.map(kpa => kpa.id);
      }
    },

      normalizeKPA(kpaTypes) {
        this.kpaTypes = kpaTypes;
        this.selectedKPATags = [];
        kpaTypes.filter((kpa) => {
          this.selectedKPATags.push({
            id: kpa.id,
            name: kpa.name,
          });
          this.optionsKPA.push({
            id: kpa.id,
            name: kpa.name,
          });
          return {};
        });
        if (this.isLinkMode) {
          this.performanceTemplate.kpa_types = kpaTypes.map(kpa => kpa.id);
        }
      },

      getLocation() {
        this.$_getHumanarLocations("").then((response) => {
          this.locations = [];
          response.data.outlets.forEach((outlet) => {
            this.locations.push({
              id: outlet.id,
              name: outlet.name,
            });
          });
        });
      },

      getJobLevels() {
        this.$_getLevels().then((response) => {
          this.jobLevels = [];
          response.data.levels.forEach((level) => {
            this.jobLevels.push({
              id: level.id,
              name: level.name,
            });
          });
        });
      },

      getFunctions() {
        this.functions = [];
        this.$_getFunctionKpis("").then((response) => {
          response.data.functions.forEach((f) => {
            this.functions.push({
              id: f.id,
              name: f.name,
            });
          });
        });
      },

      getDesignations(id) {
        this.$_getDesignations("").then((response) => {
          if (id !== "") {
            response.data.designations.filter((designation) => {
              if (id === designation.functionId) {
                this.designations.push({
                  id: designation.id,
                  name: designation.name,
                });
              }
              return {};
            });
          } else {
            this.designations = [];
            response.data.designations.filter((designation) => {
              this.designations.push({
                id: designation.id,
                name: designation.name,
              });
              return {};
            });
          }

          this.allDesignations = response.data.designations;
        });
      },

      getTemplate() {
        let performanceResponse = [];
        const typeMap = {
            'annual': '1',
            'special project': '2',
          };

          const fetchTemplate = this.$_getOneTemplate(this.$route.params.id);

          fetchTemplate.then((response) => {
            performanceResponse = response.data.PerformanceTemplate;
            this.performanceTemplate.templateId = this.$route.params.id;
            this.performanceTemplate.status = performanceResponse.status;
            this.performanceTemplate.linkId = performanceResponse.templateLinkId;
            this.contractPeriodType = typeMap[performanceResponse.template_link.type];
            this.performanceTemplate.template_link = performanceResponse.template_link;
            this.performanceTemplate.kpa_types = performanceResponse.kpa_types;
            this.kpaTypes = performanceResponse.kpa_types;
              this.linkNo = performanceResponse.linkNo;
            this.normalizeKPA(performanceResponse.kpa_types);

            if (performanceResponse.appliedToPerormance[0].id) {
              this.performanceTemplate.appliedTemplateTo.appliedToId =
                performanceResponse.appliedToPerormance[0].id;
            }

            this.performanceTemplate.title = performanceResponse.title;
            this.performanceTemplate.enable_moderation =
              performanceResponse.enable_moderation;

            performanceResponse.kpa_types.map((kpa) => {
              this.timer = setTimeout(() => {
                this.selectedKPA = kpa.id;
              }, 1000);
              return {};
            });

            this.ceoStart = performanceResponse.ceo_moderation_start ? this.setDates(
              performanceResponse.ceo_moderation_start
            ) : null;
            this.ceoEnd = performanceResponse.ceo_moderation_end ? this.setDates(performanceResponse.ceo_moderation_end) : null;
            this.functionalStart = performanceResponse.functional_moderation_start ? this.setDates(
              performanceResponse.functional_moderation_start
            ) : null;
            this.functionalEnd = performanceResponse.functional_moderation_end ? this.setDates(
              performanceResponse.functional_moderation_end
            ) : null;

            this.performanceTemplate.enable_moderation =
              performanceResponse.enable_moderation;

            this.performanceTemplate.agreement_title =
              performanceResponse.agreement_title;
            this.performanceTemplate.agreement_description =
              performanceResponse.agreement_description;

            if (this.isLinkMode) {
              this.performanceTemplate.agreement_description = '';
            }

            if (performanceResponse.appliedToPerormance[0]) {
              if (
                performanceResponse.appliedToPerormance[0]
                  .applyToAllDesignation &&
                performanceResponse.appliedToPerormance[0].applyToAllJobLevel &&
                performanceResponse.appliedToPerormance[0].applyToAllFunction &&
                performanceResponse.appliedToPerormance[0].applyToAllLocation
              ) {
                this.applyTemplate = "all";
              } else {
                this.applyTemplate = "selected";
                this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel =
                  performanceResponse.appliedToPerormance[0].applyToAllJobLevel;
                this.performanceTemplate.appliedTemplateTo.applyToAllFunction =
                  performanceResponse.appliedToPerormance[0].applyToAllFunction;
                this.performanceTemplate.appliedTemplateTo.applyToAllLocation =
                  performanceResponse.appliedToPerormance[0].applyToAllLocation;
                this.performanceTemplate.appliedTemplateTo.applyToAllDesignation =
                  performanceResponse.appliedToPerormance[0].applyToAllDesignation;
              }

              this.applyToAllLocation =
                performanceResponse.appliedToPerormance[0].applyToAllLocation;
              this.applyToAllJobLevel =
                performanceResponse.appliedToPerormance[0].applyToAllJobLevel;
              this.applyToAllFunction =
                performanceResponse.appliedToPerormance[0].applyToAllFunction;
              this.applyToAllDesignation =
                performanceResponse.appliedToPerormance[0].applyToAllDesignation;

              if (!this.applyToAllLocation) {
                performanceResponse.appliedToPerormance[0].locationIds.map(
                  (location) => {
                    this.timer = setTimeout(() => {
                      this.selectedLocation = location;
                    }, 1000);
                    return {};
                  }
                );
              }

              if (!this.applyToAllJobLevel) {
                performanceResponse.appliedToPerormance[0].jobLevelIds.map(
                  (levels) => {
                    this.timer = setTimeout(() => {
                      this.selectedLevel = levels;
                    }, 1000);
                    return {};
                  }
                );
              }

              if (!this.applyToAllFunction) {
                performanceResponse.appliedToPerormance[0].functionIds.map(
                  (func) => {
                    this.timer = setTimeout(() => {
                      this.selectedFunctionResponse = func;
                    }, 1000);
                    return {};
                  }
                );
              }

              if (!this.applyToAllDesignation) {
                performanceResponse.appliedToPerormance[0].designationIds.map(
                  (designation) => {
                    const filtered = this.designations.filter(
                      (el) => el.id === designation
                    );

                    filtered.map((val) => {
                      this.filteredDesignations.push({
                        id: val.id,
                        name: val.name
                      });
                      return {};
                    })
                    return {};
                  }
                );

                this.designations = this.filteredDesignations;

                performanceResponse.appliedToPerormance[0].designationIds.map(
                  (designation) => {
                    this.timer = setTimeout(() => {
                      this.selectedDesignation = designation;
                    }, 2000);
                    return {};
                  }
                );
              }
            }

            this.loading = false;
          });
          this.loading = false;
      },



      checkTemplateEmployeeApplication() {
        switch (this.applyTemplate) {
          case "selected":
            if (
              this.applyToAllLocation &&
              this.applyToAllJobLevel &&
              this.applyToAllFunction &&
              this.applyToAllDesignation
            ) {
              this.applyTemplate = "all";
            }
            break;
          default:
            break;
        }
      },

      moderationStart(value) {
        this.disabledDates.to = new Date(value.valueOf() + 1000 * 60 * 60 * 24);
        this.disableModerationDates.to = new Date(
          value.valueOf() + 1000 * 60 * 60 * 24
        );
      },

      moderationEnd(value) {
        this.disabledDates.to = new Date(value.valueOf() + 1000 * 60 * 60 * 24);
        this.disableModerationDates.to = new Date(
          value.valueOf() + 1000 * 60 * 60 * 24
        );
      },

      formatCycleDate(value) {
        const startDate = `${value}/${new Date().getFullYear()}`;

        const [mm, dd, yyyy] = startDate.split("/");

        return new Date(`${dd}-${mm}-${yyyy}`).toISOString();
      },

      getAppraisalCycle() {
      this.$_getAppraisalCycle(this.agreementQuery()).then((response) => {
        const appraisal = response.data.AppraisalCycle;
        if (appraisal[0].status) {
          this.cycleStartDate = this.setDates(appraisal[0].cycle_start_date);
          this.cycleEndDate = this.setDates(appraisal[0].cycle_end_date);
          this.performanceTemplate.agreement_start = appraisal[0].agreement_start;
          this.performanceTemplate.agreement_end = appraisal[0].agreement_end;
          this.agreementStartDate = this.setDates(appraisal[0].agreement_start);
          this.agreementEndDate = this.setDates(appraisal[0].agreement_end);
          this.appraisalCycleId = appraisal[0].cycles[0].appraisalCycleId;

          // this.frequency = "1";
          let freq = '1';
          const freqMap = {
            'annual': '1',
            'bi-annual': '2',
            'quarterly': '4',
            'custom': '5',
          };

          if (appraisal[0].appraisal_frequency && freqMap[appraisal[0].appraisal_frequency.toLowerCase()]) {
            freq = freqMap[appraisal[0].appraisal_frequency.toLowerCase()];
          }
          this.frequency = freq;
          this.payloadFrequency = freq;
          this.templateFrequency = freq;

          // Prefill appraisal_cycles from backend cycles
          this.appraisal_cycles = [];
          if (Array.isArray(appraisal[0].cycles)) {
            appraisal[0].cycles.forEach((cycle, idx) => {
              this.appraisal_cycles.push({
                name: cycle.name || this.getCycleName(Number(freq), idx),
                label: cycle.label || this.getCycleLabel(Number(freq), idx),
                appraisal_starts: this.setDates(cycle.appraisal_starts),
                appraisal_ends: this.setDates(cycle.appraisal_ends),
                weight: cycle.weight || '',
                isLocked: false,
                id: cycle.id || null,
              });
            });
          }

          this.originalCycleData = {
            cycleStartDate: this.cycleStartDate,
            cycleEndDate: this.cycleEndDate,
            agreementStartDate: this.agreementStartDate,
            agreementEndDate: this.agreementEndDate,
            frequency: this.frequency,
            appraisal_cycles: [...this.appraisal_cycles]
          };
          this.performanceTemplate.appraisalCycleId = appraisal[0].cycles[0].appraisalCycleId;

          if (appraisal[0].cycles.length > 0) {
            this.performanceTemplate.performance_agreement.appraisal_cycles =
              appraisal[0].cycles;

            let endDate = '';

            appraisal[0].cycles.map((cycle) => {
              endDate = cycle.appraisal_ends;
              return {};
            });

            this.appraisalEndDate = new Date(this.formatCycleDate(endDate));

            this.disabledDates.to = new Date(
              this.appraisalEndDate.valueOf() + 1000 * 60 * 60 * 24
            );
            this.disableModerationDates.to = new Date(
              this.appraisalEndDate.valueOf() + 1000 * 60 * 60 * 24
            );

            this.appraisalCycleId =
            appraisal[0].cycles[0].appraisalCycleId;

          }

        }

      });
    },

      handleBreadcrumbClick(event) {
        this.$router.push({
          name: event,
        });
      },

      // Appraisal cycle creation methods
      createAppraisalCycle() {
        return new Promise((resolve, reject) => {
          this.appraisalCyclePayload.appraisal_cycles = [];

          this.optionsPeriod.filter((freq) => {
            if (freq.id === Number(this.frequency)) {
              this.appraisalCyclePayload.appraisal_frequency = freq.name;
            }
            return {};
          });

          this.appraisalCyclePayload.status = "active";

          // Prepare appraisal cycles data
          this.appraisal_cycles.map((cycle) => {
            this.appraisalCyclePayload.appraisal_cycles.push({
              name: cycle.name !== null ? cycle.name : "Annual Appraisal",
              appraisal_starts: this.formatDate(cycle.appraisal_starts),
              appraisal_ends: this.formatDate(cycle.appraisal_ends),
              cycleId: cycle.id,
            });
            return {};
          });

          this.appraisalCyclePayload.orgId = this.$orgId;
          this.appraisalCyclePayload.cycle_start_date = this.formatDate(this.cycleStartDate);
          this.appraisalCyclePayload.cycle_end_date = this.formatDate(this.cycleEndDate);
          this.appraisalCyclePayload.agreement_start = this.formatDate(this.agreementStartDate);
          this.appraisalCyclePayload.agreement_end = this.formatDate(this.agreementEndDate);

          this.$_createAppraisalCycle(this.appraisalCyclePayload)
            .then((response) => {
              this.$toasted.success("Appraisal cycle created successfully", { duration: 3000 });
              const cycleId = response.data.AppraisalCycle?.id;
              resolve(cycleId);
            })
            .catch((error) => {
              const errorMessage = error.response?.data?.message || "";
              if (errorMessage.includes("Already Exist") || errorMessage.includes("already exists")) {
                // If cycle already exists, resolve successfully without showing error
                this.$toasted.info("Appraisal cycle already exists", { duration: 3000 });
                // Try to get the existing cycle ID or resolve with null
                resolve(null);
              } else {
                // For other errors, show the error message and reject
                this.$toasted.error(error.response?.data?.message || "Failed to create appraisal cycle", {
                  duration: 5000,
                });
                reject(error);
              }
            });
        });
      },

      validateCycleData() {
        if (this.frequency !== "1") {
          this.cycleValidation = this.appraisal_cycles.every(
            (item) => item.name && item.appraisal_starts && item.appraisal_ends
          );
        } else {
          this.cycleValidation = this.appraisal_cycles.every(
            (item) => item.appraisal_starts && item.appraisal_ends
          );
        }

        // Also validate that we have the basic cycle dates
        if (!this.cycleStartDate || !this.cycleEndDate || !this.agreementStartDate || !this.agreementEndDate) {
          this.cycleValidation = false;
        }

        return this.cycleValidation;
      },
    },

    mounted() {
      this.getTemplate();
      this.getLocation();
      this.getJobLevels();
      this.getFunctions();
      this.getAppraisalCycle();
      if (this.$route.params.id === "new") {
        this.$nextTick(() => {
          this.prefillDefaultCycleData();
        });
      } else {
        this.getDesignations("");
      }
    },

  };
  </script>

  <style lang="scss" scoped>
  .label label {
    display: none !important;

  }

  ::v-deep .no-outline-select > span > select.cloudenly-input {

  }


  ::v-deep .no-outline-select > span > select.cloudenly-input,
  ::v-deep .labeldisplay > span > input.cloudenly-input
   {
   border:0px;
   text-transform: capitalize;
  }
  ::v-deep.no-outline-select > label,
  ::v-deep .labeldisplay > div > label
   {
    display: none !important;
  }


  .pr14{
    padding-right: 8px !important;
  }

  .bg-disabled {
    background-color: #eeeeee;
    color: #878e99;
  }
  .cld-input {
    border: 0px !important;
    border-radius: 8px !important;
  }
  .cardClass {
    box-shadow: none !important;
  }

  .input-with-icon-container {
    width: 100%;
    height: 40px;
    margin: auto;
    display: flex;
    justify-items: start;
    align-items: center;
    background-color: #F7F7FF;
    border-radius: 6px;
    border: none !important;
    outline: none !important;
  }

  .input-with-icon-container input{
    width: 100%;
    height: 100%;
    background-color: #F7F7FF !important;
    border: none !important;
    outline: none !important;
  }


  .moderator-item {
    transition: transform 0.2s ease;
  }

  .drag-handle {
    user-select: none;
    font-size: 1.2em;
    color: #666;
  }

  .moderator-item.dragging {
    opacity: 0.5;
    background: #f0f0f0;
  }

  .moderator-item.drop-target {
    border-top: 2px solid #3b82f6;
  }
  </style>
